import { Checkbox } from '@material-ui/core';
import { useObserver } from 'mobx-react';
import React from 'react';
import KendoDataGridShell from '../../../../components/KendoDataGrid/KendoDataGridShell';
import OverflowTooltip from '../../../../components/OverflowTooltip';
import { FBProcedureItemConfig } from '../../../FBProcedureItem/FBProcedureItem.types';
import { FB } from '../../../helpers';
import { getEquipmentShellColumns } from './shellColumns';

interface ViewProps {
  items?: FBProcedureItemConfig[]
}

const EquipmentTitle: React.FC<{ item: FBProcedureItemConfig }> = ({ item }) => {
  const { procedureCatalogState } = FB.useStores();
  const displayValue = useObserver(() => {
    const fieldValue = procedureCatalogState?.getEquipmentRevisionLabel(item.title) || item.title;
    return item.type ? `${item.id}:${fieldValue}` : fieldValue;
  });

  return (
    <OverflowTooltip title={displayValue} placement="top" interactive arrow deferred>
      {displayValue}
    </OverflowTooltip>
  );
};

const View: React.FC<ViewProps> = ({ items = [] }) => (
  <div data-cy="lhr-equipment-table">
    <KendoDataGridShell
      columns={getEquipmentShellColumns({ isMPIProcedure: true })}
      interactive
      dataCy="mpi-equipment-view-table"
    >
      {items.map((item) => (
        <tr key={item.id} data-cy={`equip-row-${item.id}`}>
          <td data-cy="title-cell">
            <EquipmentTitle item={item} />
          </td>
          <td data-cy="LHRTparameter-cell">
            <Checkbox checked={Boolean(item.LHRTparameter)} disabled color="primary" />
          </td>
        </tr>
      ))}
    </KendoDataGridShell>
  </div>
);

export default View;
